import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthContext';
import { authErrorMessage, changeOwnPassword } from '../auth/login';

export function AccountPage() {
  const { session } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState<{ ok: boolean; text: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const isPasswordUser = session?.user.providerData.some((p) => p.providerId === 'password');

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (next.length < 10 || !/[a-zA-Z]/.test(next) || !/\d/.test(next)) {
      setMessage({ ok: false, text: 'Usa al menos 10 caracteres, con letras y números.' });
      return;
    }
    if (next !== confirm) {
      setMessage({ ok: false, text: 'Las contraseñas nuevas no coinciden.' });
      return;
    }
    setBusy(true);
    try {
      await changeOwnPassword(current, next);
      setCurrent('');
      setNext('');
      setConfirm('');
      setMessage({ ok: true, text: 'Tu contraseña se actualizó.' });
    } catch (e) {
      setMessage({ ok: false, text: authErrorMessage(e) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="page">
      <div className="page__intro">
        <h1 className="t-display">Tu cuenta</h1>
        <p className="t-meta admin__muted">{session?.email}</p>
      </div>
      {isPasswordUser ? (
        <form className="page__pad admin__form" onSubmit={(e) => void onSubmit(e)}>
          <h2 className="t-nav admin__heading">Cambiar contraseña</h2>
          <label className="field">
            <span className="field__label">Contraseña actual</span>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
            />
          </label>
          <label className="field">
            <span className="field__label">Contraseña nueva</span>
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
            />
          </label>
          <label className="field">
            <span className="field__label">Confirma la contraseña nueva</span>
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </label>
          <button type="submit" className="btn" disabled={busy || !current || !next}>
            Guardar contraseña
          </button>
          {message ? (
            <p className={message.ok ? 'admin__ok' : 'field__error'}>{message.text}</p>
          ) : null}
        </form>
      ) : (
        <p className="page__pad empty__text">
          Entras con Google; tu contraseña se administra en tu cuenta de Google.
        </p>
      )}
    </main>
  );
}
